module.exports = "- React is awesome. JSX is shit.\n\n- JSX is life. JSX is love. JSX is puppies and hot chocolate on a rainy day."


//////////////////
// WEBPACK FOOTER
// ./src/slides/07_jsx/notes_4.md
// module id = 1502
// module chunks = 0